export { default } from "./Dashboard.vue"
